import { LanguageList } from '@/src/components/language/LanguageList'
import { VpButton } from '@vtmn-play/react'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'
import { usePageHeaders } from '@/src/hooks/use-page-headers/usePageHeaders'
import { userPreferencesPort } from '@/infra/config/beans'
import { useUserPreferences } from '@/src/hooks/use-user-preference-port/useUserPreferencePort'
import { Language, AVAILABLE_LANGUAGES } from '@/domains/Language'
import { match } from 'ts-pattern'
import { useQueryClient } from '@tanstack/react-query'

const SelectLangPage = () => {
  const navigate = useNavigate()
  const queryClient = useQueryClient()
  const { t, i18n } = useTranslation('common')
  usePageHeaders(t('pages.select-lang.title'))
  const { language, store, team } = useUserPreferences(userPreferencesPort)

  const getNextUrl = () =>
    match({ store: !!store, team: !!team })
      .with({ store: false }, () => '/select-store')
      .with({ store: true, team: false }, () => '/select-team')
      .otherwise(() => '/account')

  const currentLangId = language?.id ?? null

  const handleSelect = async (language: Language) => {
    userPreferencesPort.upsertLanguageId(language.id)
    await queryClient.invalidateQueries()
    await i18n.changeLanguage(language.code)
  }

  return (
    <div className="h-full flex flex-col bg-white">
      <div className="flex-1 overflow-y-auto px-5 pb-6 pt-5">
        <LanguageList
          languages={AVAILABLE_LANGUAGES}
          selectedId={currentLangId}
          onSelect={handleSelect}
        />
      </div>

      <div className="sticky bottom-0 px-5 pb-3">
        <VpButton
          className="w-full"
          disabled={!language?.id}
          data-testid="continue-button"
          shape="squared"
          onClick={() => navigate(getNextUrl(), { viewTransition: true })}
        >
          {t('global.continue')}
        </VpButton>
      </div>
    </div>
  )
}

export default SelectLangPage
